import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {HowItWorksSectionComponent} from './how-it-works-section.component'
import {ContentSectionModule} from '../../../../craft/content-section/content-section.module'
import {StepByStepModule} from '../../../../craft/step-by-step/step-by-step.module'
import {TranslocoModule} from '@ngneat/transloco'
import {TabsModule} from '../../../../craft/tabs/tabs.modules'

@NgModule({
  declarations: [HowItWorksSectionComponent],
  exports: [HowItWorksSectionComponent],
  imports: [CommonModule, ContentSectionModule, StepByStepModule, TranslocoModule, TabsModule],
})
export class HowItWorksSectionModule {}
